import * as React from 'react';
import { GapSizeType } from '../../../../theme/type/gap-type';
import { cn, marginBottomClass } from '../../../../utils/tailwind';

interface FormItemPropsInterface {
    children: React.ReactChild;
    gapTop?: GapSizeType;
    gapBottom?: GapSizeType;
}

export const FormItem: React.FC<FormItemPropsInterface> = ({ children, gapTop = 'none', gapBottom = 'small' }) => {
    return (
        <div className={cn('w-full flex-col', marginBottomClass[gapTop], marginBottomClass[gapBottom])}>{children}</div>
    );
};
